import { Dispatch } from 'react';
import { TMaintenancePackageActionTypes } from '../types';
import { SET_LOADING } from 'src/contexts/types';
import { handleError } from 'src/contexts/utils/handleError';
import { CREATE_MAINTENANCE_PACKAGE } from '../constants/actions';
import { HEADERS } from 'src/constants/headers';
import { ApiV2 } from 'src/api/apiv2';
import { TAPIOptions } from 'src/constants/apis/types';
import { IMaintenancePackage } from 'src/interfaces/maintenancePackage';

export const createMaintenancePackage = async (
    dispatch: Dispatch<TMaintenancePackageActionTypes>,
    values: Partial<IMaintenancePackage>,
    options: TAPIOptions = {
        isReadPermissionNecessary: false,
        select: '',
        populate: [],
    }
): Promise<Partial<IMaintenancePackage> | undefined> => {
    dispatch({ type: SET_LOADING });
    const { select, populate } = options;

    try {
        const res = await ApiV2.post(
            `/maintenance-packages/create`,
            { select, populate, ...values },
            HEADERS({
                isReadPermissionNecessary:
                    options.isReadPermissionNecessary || false,
            })
        );

        dispatch({
            type: CREATE_MAINTENANCE_PACKAGE,
            payload: res.data.data,
        });

        return res.data.data;
    } catch (error) {
        if (error instanceof Error) dispatch(handleError(error));
    }
};
